// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"ui_wrapperLoader__t70Rq"};